export default {
    computed: {
        formattedUserParameters() {
            if(!this.userParameter) return {}
            let formattedUserParameters = {...this.userParameter}

            // the server expects ids as string
            let categoryId = this.userParameter.categoryId
            if(categoryId && categoryId.length) {
                categoryId = categoryId.join()
                formattedUserParameters = {...formattedUserParameters, categoryId}
            }

            if(this.userParameter.forceAllCategories) {
                formattedUserParameters = {...formattedUserParameters, forceAllCategories: this.userParameter.forceAllCategories}
            }

            // the server expects ids as string
            let typeId = this.userParameter.typeId
            if(typeId && typeId.length) {
                typeId = typeId.join()
                formattedUserParameters = {...formattedUserParameters, typeId}
            }

            // free text needs sql wildcards
            let filterText = this.userParameter.filterText
            if(filterText) {
                let formattedFilterText = '%' + filterText.replace(/['"!?#$%&]/g, '') + '%'
                formattedUserParameters = {
                    ...formattedUserParameters,
                    name: formattedFilterText,
                    teaser: formattedFilterText,
                    offerNumber: formattedFilterText,
                    person: formattedFilterText,
                    location: formattedFilterText,
                }
            }

            // overwrite offerNumber parameter on click or parent site url parameter
            // remove name and teaser because of query nature
            let offerNumberOverwrite = this.userParameter.offerNumberOverwrite
            if(offerNumberOverwrite) {
                formattedUserParameters = {
                    ...formattedUserParameters,
                    name: null,
                    teaser: null,
                    person: null,
                    location: null,
                    offerNumber: offerNumberOverwrite,
                }

            }

            // there are two separate options each for start and end dates
            let dateFrom = this.userParameter.dateFrom
            if(dateFrom) {
                formattedUserParameters = {
                    ...formattedUserParameters,
                    minStartDate: dateFrom,
                }
            }
            let dateTo = this.userParameter.dateTo
            if(dateTo) {
                formattedUserParameters = {
                    ...formattedUserParameters,
                    maxEndDate: dateTo,
                }
            }
            return formattedUserParameters
        }
    }
}
